import { EntityWithStatusService } from './EntityWithStatusService';
import { IEntityChildren, IEntityDescription1, IRiskAppIncidentAction } from '../types';
import { EntityStatus } from '../refData/EntityStatus';
import { AppGlobals } from '../AppGlobals';

export class RiskAppIncidentActionService extends EntityWithStatusService<IRiskAppIncidentAction> {
    public readonly parentEntities = [
        'Incident($select=OwnerTypeID,OwnerL0ID,OwnerL1ID,OwnerL2ID,OwnerL3ID,ManagedByTypeID,ManagedByL2ID,ManagedByL3ID)'
    ];

    protected childrenEntities = ['Contributors($expand=ContributorUser)'];

    constructor() {
        super(`/RiskAppIncidentActions`);
    }

    public readAllForList(includeClosed?: boolean, incidentID?: number): Promise<IRiskAppIncidentAction[]> {
        return this.readAll(
            `?$select=ID,Title,ActualStartDate,TargetCompletionDate`
            + `&$orderby=Title`
            + `&$expand=Incident($select=Title),Stage($select=Title),EntityStatus($select=Title),ActionOwner($select=Title),Contributors($expand=ContributorUser($select=Title))`
            + `&$filter=CustomerID eq ${AppGlobals.CustomerID}`
            + (includeClosed ? `` : ` and EntityStatusID eq ${EntityStatus.Open}`)
            + (incidentID ? ` and IncidentID eq ${incidentID}` : '')
        );
    }

    public async entityChildren(id: number): Promise<IEntityChildren[]> {
        const entityUrl = `${this.entityUrl}(${id})`;
        const evidences = (await this.axiosGet(`${entityUrl}/RiskAppEvidences?$select=ID&$top=10`)).data.value;
        return [
            { ChildType: 'Comments and File Attachments', CanBeAdopted: false, ChildIDs: (await evidences).map((w: { ID: any }) => w.ID) }
        ];
    }

}